import React from "react";
import ReverseTimerClock from "components/ReverseTimerClock";
import FinishButton from "components/surveys/FinishButton";
import { FiCheck, FiBarChart2 } from "react-icons/fi";

const SurveyCard = ({ item, isSelected, onCardClick, showTimers }) => {
  const resultChoice = item.choices?.find((c) => c.id === item.result)?.value;
  const choicesCount = item.choices?.length || 0;

  return (
    <div
      className={`relative w-full rounded-2xl border transition-all duration-200 flex flex-col justify-between p-5 ${
        isSelected
          ? "border-emerald-500 ring-2 ring-emerald-500/20 bg-emerald-50/20 shadow-md"
          : "border-slate-200/80 bg-white hover:border-slate-300 hover:shadow-md"
      }`}
    >
      {/* Selected Indicator */}
      {isSelected && (
        <div className="absolute top-3 right-3 w-5 h-5 rounded-full bg-emerald-500 text-white flex items-center justify-center text-xs shadow-sm z-10">
          <FiCheck strokeWidth={3} size={12} />
        </div>
      )}

      {/* Main Clickable Area */}
      <div
        onClick={onCardClick}
        className="flex-1 flex flex-col justify-between cursor-pointer group"
      >
        <div>
          {/* Header: Survey tag & Results / Choices count */}
          <div className="flex items-center justify-between gap-3 mb-3.5">
            <div className="flex items-center gap-2">
              <span className="p-2 rounded-xl bg-violet-50 text-violet-600 border border-violet-100 flex items-center justify-center">
                <FiBarChart2 size={16} />
              </span>
              <div>
                <span className="inline-flex items-center text-[11px] font-medium px-2.5 py-0.5 rounded-full bg-violet-50 text-violet-700 border border-violet-100">
                  Հարցում
                </span>
                {choicesCount > 0 && (
                  <span className="text-xs text-slate-400 ml-2">
                    {choicesCount} տարբերակ
                  </span>
                )}
              </div>
            </div>

            {/* Status / Result Badges */}
            {item.type === "finished" && resultChoice && (
              <span className="inline-flex items-center gap-1 text-[11px] font-semibold px-2.5 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
                <FiCheck size={11} strokeWidth={2.5} /> {resultChoice}
              </span>
            )}
          </div>

          {/* Content (Title & Description) */}
          <div className="flex gap-4">
            <div className="flex-1 min-w-0">
              {item._highlightResult?.title?.value ? (
                <div
                  className="highlighted text-sm sm:text-base font-semibold text-slate-900 leading-snug line-clamp-2 group-hover:text-indigo-600 transition-colors"
                  dangerouslySetInnerHTML={{
                    __html: item._highlightResult?.title?.value,
                  }}
                />
              ) : (
                <h4 className="text-sm sm:text-base font-semibold text-slate-900 leading-snug line-clamp-2 group-hover:text-indigo-600 transition-colors">
                  {item.title}
                </h4>
              )}

              {item.description && (
                <p className="text-xs text-slate-500 leading-relaxed line-clamp-2 mt-1.5">
                  {item.description}
                </p>
              )}
            </div>

            {/* Optional distinct thumbnail */}
            {item?.image && (
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl overflow-hidden shrink-0 border border-slate-100 bg-slate-50">
                <img
                  src={item.image}
                  alt=""
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Timers & Actions (if showTimers is true) */}
      {showTimers && (
        <div className="mt-4 pt-4 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-4 sm:gap-6 w-full sm:w-auto">
            <ReverseTimerClock
              title="Քվեարկության ավարտ"
              targetTime={item.type === "finished" ? 0 : item.endOfVoting}
            />
            <ReverseTimerClock
              title="Վերջնաժամկետ"
              targetTime={item.type === "finished" ? 0 : item.deadline}
            />
          </div>

          <div className="shrink-0 w-full sm:w-auto">
            <FinishButton survey={item} />
          </div>
        </div>
      )}
    </div>
  );
};

export default SurveyCard;
